mutation EntityTagApprovalCreate(
  $input: EntityTagApprovalCreateInput!
) {
  entityTagApprovalCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
